module.exports = "@media only screen and (max-width: 896px) {\n  .earnedCertfPanel {\n    top: 35px!important;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/isolated-score-card/isolated-score-card.component.css
// module id = ./src/app/Screens/isolated-score-card/isolated-score-card.component.css
// module chunks = main